export const StaticWidgetsData = [
    {
        id: 1,
        title: 'Earnings',
        counter: 6659,
        svg: 'earningSvg',
        class: 'progress-gradient-secondary',
        progress: '75%'
    },
    {
        id: 2,
        title: 'Products',
        counter: 9856,
        svg: 'productSvg',
        class: 'progress-gradient-success',
        progress: '60%'
    },
    {
        id: 3,
        title: 'Messages',
        counter: 893,
        svg: 'messageSvg',
        class: 'progress-gradient-primary',
        progress: '48%'
    },
    {
        id: 4,
        title: 'New User',
        counter: 45631,
        svg: 'newuserSvg',
        class: 'progress-gradient-danger',
        progress: '48%'
    },
];

export  const SalesData = [
    {
        id: 1,
        icon: 'icofont icofont-arrow-down font-primary',
        iconClass:'widget-icon bg-light-primary',
        title: 'Today',
        counter:'2598',
        class: 'font-primary',
        numbers: '-36%($258)'
    },
    {
        id: 2,
        icon: 'icofont icofont-arrow-down font-secondary',
        iconClass:'widget-icon bg-light-secondary',
        title: 'Month',
        counter:'6954',
        class: 'font-secondary',
        numbers: '-15%($369)'
    },
    {
        id: 3,
        icon: 'icofont icofont-arrow-up font-success',
        iconClass:'widget-icon bg-light-success',
        title: 'Week',
        counter:'63147',
        class: 'font-success',
        numbers: '+65%($69)'
    },
    {
        id: 4,
        icon: 'icofont icofont-arrow-up font-danger',
        iconClass:'widget-icon bg-light-danger',
        title: 'Year',
        counter:'9198',
        class:'font-danger',
        numbers: '+90%($354)'
    }
];

export const OrderDetailsData = [
    {
        id: 1,
        iconClass: 'bg-light-primary',
        svg1: 'neworderSvg',
        title: 'New Order',
        count: '6981',
        fontClass: 'font-primary',
        icon: ' icofont icofont-arrow-up',
        percent: '68%',
        svg2: <SVG68 />
    },
    {
        id: 2,
        iconClass: 'bg-light-warning',
        svg1: 'pendingorderSvg',
        title: 'Pending  Order',
        fontClass: 'font-warning',
        count: '783',
        icon: 'icofont icofont-arrow-down',
        percent: '12%',
        svg2: <SVG98 />
    },
    {
        id: 3,
        iconClass: 'bg-light-success',
        svg1: 'deliveredorderSvg',
        title: 'Delivered Order',
        fontClass: 'font-success',
        count: '6314',
        icon: 'icofont icofont-arrow-up',
        percent: '50%',
        svg2: <SVG50 />
    },
    {
        id: 4,
        iconClass: 'bg-light-danger',
        svg1: 'cancelledorderSvg',
        title: 'Cancelled Order',
        fontClass: 'font-danger',
        count: '69',
        icon: 'icofont icofont-arrow-up',
        percent: '20%',
        svg2: <SVG20 />
    },
];

export const RecentActivityData = [
    {
        id: 1,
        bgClass: 'bg-primary',
        title: 'Any desktop publishing pack ages editors.',
        date: '25 July 2023 | 20 hours ago'
    },
    {
        id: 2,
        bgClass: 'bg-secondary',
        title: `Renewed account with this new premium plan.`,
        date: '25 July 2023 | 20 hours ago'
    },
    {
        id: 3,
        bgClass: 'bg-success',
        title: 'Micron to build largest chip factory in US history.',
        date: '25 July 2023 | 20 hours ago'
    },
    {
        id: 4,
        bgClass: 'bg-info',
        title: 'Share A Case Study On One Of Your Customers.',
        date: '25 July 2023 | 20 hours ago'
    },
];

export const BrowserData = [
    {
        id: 1,
        browser: require("../../../assets/images/dashboard/chrom.png"),
        name: 'Google Chrome',
        daily: '28%',
        weekly: '78%',
        monthly: '36%'
    },
    {
        id: 2,
        browser: require("../../../assets/images/dashboard/firefox.png"),
        name: 'Mozilla Firefox',
        daily: '28%',
        weekly: '78%',
        monthly: '36%'
    },
    {
        id: 3,
        browser: require("../../../assets/images/dashboard/safari.png"),
        name: 'Safari (web browser)',
        daily: '28%',
        weekly: '78%',
        monthly: '36%'
    },
    {
        id: 4,
        browser: require("../../../assets/images/dashboard/opera.png"),
        name: 'Opera (web browser)',
        daily: '28%',
        weekly: '78%',
        monthly: '36%'
    }
];

export const SocialData = [
    {
        id: 1,
        img: require('../../../assets/images/general-widget/svg-icon/2.svg'),
        name: 'Facebook',
        posts: '6589',
        likes: '6589'
    },
    {
        id: 2,
        img:require('../../../assets/images/general-widget/svg-icon/3.svg'),
        name: 'Twitter',
        posts: '920',
        likes: '4'
    },
    {
        id: 3,
        img: require('../../../assets/images/general-widget/svg-icon/6.svg'),
        name: 'Linkedin',
        posts: '1234',
        likes: '4369'
    },
    {
        id: 4,
        img: require('../../../assets/images/general-widget/svg-icon/4.svg'),
        name: 'Instagram',
        posts: '369',
        likes: '3489'
    },
];

export const productData = [
    {
        id: 1,
        details: 'Men Casual Shirt.',
        qty: '10',
        price: '$2323',
        status: 'done',
        class: 'badge badge-light-success'
    },
    {
        id: 2,
        details: 'Rayon Women Regular Top',
        qty: '20',
        price: '$4123',
        status: 'pending',
        class:"badge badge-light-warning"
    },
    {
        id: 3,
        details: 'Flower Printed Dress',
        qty: '40',
        price: '$6246',
        status: 'done',
        class: 'badge badge-light-success'
    },
    {
        id: 4,
        details: 'Polyester Women Dress',
        qty: '05',
        price: '$6527',
        status: 'In process',
        class: 'badge badge-light-info'
    },
    {
        id: 5,
        details: 'Cotton Regular T-Shirt',
        qty: '08',
        price: '$8553',
        status: 'pending',
        class: 'badge badge-light-warning'
    },
    {
        id: 6,
        details: 'Printed Sleev Dress',
        qty: '12',
        price: '$6523',
        status: 'pending',
        class: 'badge badge-light-warning'
    }
];


export const EmployeeData = [
    {
        id: 1,
        img: require('../../../assets/images/user/4.jpg'),
        name: 'John Dio',
        pera: '(14+ Online)',
        designation: 'Designer',
        skillClass: 'bg-primary',
        skill: '30%',
        exp: '2 Year'
    },
    {
        id: 2,
        img: require('../../../assets/images/user/1.jpg'),
        name: 'Holio Mako',
        pera: '(250+ Online)',
        designation: 'Developer',
        skillClass: 'bg-secondary',
        skill: '70%',
        exp: '3 Year'
    },
    {
        id: 3,
        img: require('../../../assets/images/user/5.jpg'),
        name: 'Mohsib lara',
        pera: '(99+ Online)',
        designation: 'Tester',
        skillClass: 'bg-primary',
        skill: '60%',
        exp: '5 Month'
    },
    {
        id: 4,
        img: require('../../../assets/images/user/6.jpg'),
        name: 'Hileri Soli',
        pera: '(150+ Online)',
        designation: 'Designer',
        skillClass: 'bg-secondary',
        skill: '30%',
        exp: '3 Month'
    },
    {
        id: 5,
        img: require('../../../assets/images/user/7.jpg'),
        name: 'Pusiz bia',
        pera: '(14+ Online)',
        designation: 'Designer',
        skillClass: 'bg-primary',
        skill: '90%',
        exp: '5 Year'
    }
]





